export default {"src":"/_next/static/image/public/images/profile_placeholder.c5f621ee048dffb309563d11297f079f.svg","height":100,"width":100};